




























































































































































































































































































































































import axios from 'axios';
import Comprobante from '@/models/Comprobante';
import Resumen from '@/models/Resumen';
import Grano from '@/models/Grano';
import Cosecha from '@/models/Cosecha';
import Entidad from '@/models/Entidad.vue';
import Total from '@/models/Total';
import TipoComprobante from '@/models/TipoComprobante';
import ValorGrano from '@/models/TipoComprobante';
import Expand from '@/components/Expand.vue';
import Detalle from '@/components/Detalle.vue';
import Currency from '@/components/Currency.vue';
export default {
	name: 'Granos',
	inject: ['responsive'],
	props: {
		directo: Boolean,
	},
	components: {
		Expand,
		Detalle,
		Currency,
	},
	data() {
		return {
			pickerBeginDateAfterH: {
				disabledDate: this.disabledDateH,
			},
			pickerBeginDateAfterD: {
				disabledDate: this.disabledDateD,
			},
			radio: 1,
			vis: true,
			config: {},
			codcomexpand: '',
			codtalexpand: '',
			numeroexpand: '',
			toggle_exclusive: 2,
			recordSelected: {},
			searchDrawer: false,
			detailsDrawer: false,
			imprimiendo: false,
			descargando: false,
			imprime: false,
			tableProductos: false,
			tableGranos: true,
			loading: true,
			loadingExpand: false,
			expandido: false,
			grano: 0,
			start: 0,
			limit: 7,
			showBtnMore: false,
			granoselected: 0,
			active_tab: '',
			tableDataAll: [],
			tableDataGroup: [],
			tableExpand: [],
			indexGroup: 0,
			resumen: '',
			codcom: '',
			scrollPosition: 0,
			lastScrollTop: window.pageYOffset || document.documentElement.scrollTop,
			url: './api/public/proxy/cgi/etenet_fichadet',
			type: '',
			searchForm: {
				fechaDesde: null,
				fechaHasta: null,
				fechaDesdeM: '',
				fechaHastaM: '',
				comprobantes: [],
				cosechaselect: [],
				rangofecha: [],
			},
			searchRules: {
				fechaHasta: [{ type: 'date', required: true, message: 'Seleccione una fecha hasta', trigger: 'change' }],
			},
			gray: true,
		};
	},
	watch: {
		granoselected() {
			this.resetData();
			this.callResumen();
		},
		primergrano(primer) {
			this.$router.push(`/1/granos/${primer}`);
			this.granoselected = primer;
		},
	},
	computed: {
		descEntidadSelected() {
			return this.$store.state.perfil.descEntidadSelected;
		},
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
		carouselItems() {
			return Math.ceil(this.valores.length / 6);
		},
		carouselItemsMobile() {
			return Math.ceil(this.valores.length / 1);
		},
		valores(): Array<{ id: number; descri: string; valor: number; signo?: string }> {
			return this.$store.state.granos.valoresdegranos || [];
		},
		resumenes() {
			return this.$store.state.granos.resumenes;
		},
		tableData(): Comprobante[] {
			return this.$store.state.granos.tableData;
		},
		tipocomprobantes(): TipoComprobante[] {
			return this.$store.state.granos.tipocomprobantes;
		},
		tipoctasctes() {
			return this.$store.state.granos.tipoctasctes;
		},
		granos(): Grano[] {
			// return this.$store.state.granos.granos;
			const g = this.$store.state.granos && this.$store.state.granos.granos;
			return Array.isArray(g) ? (g as Grano[]) : [];
		},
		cosechas(): Cosecha[] {
			return this.$store.state.granos.cosechas;
		},
		totales(): Total[] {
			return this.$store.state.granos.totales;
		},
		primergrano(): Grano {
			return this.$store.state.granos.primergrano;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		numeric: function (value) {
			return new Intl.NumberFormat('de-DE').format(value);
		},
	},
	methods: {
		blurIfRadioActive(evt?: Event) {
			// Si el foco está en el radio nativo, lo sacamos
			const el = document.activeElement as HTMLElement | null;
			if (el && el.classList && el.classList.contains('el-radio__original')) el.blur();
		},
		openSearch() {
			const active = document.activeElement as HTMLElement | null;
			if (active) active.blur(); // << saca el foco del radio antes de abrir
			this.searchDrawer = true;
		},
		disabledDateD(date) {
			if (this.searchForm.fechaHasta) return date > this.searchForm.fechaHasta;
			else return false;
		},
		disabledDateH(date) {
			if (this.searchForm.fechaDesde) return date < this.searchForm.fechaDesde;
			else return false;
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		tableRowClassName({ row, rowIndex }): string {
			let bg,
				clase: string = '';
			if (rowIndex === 0) {
				bg = 'bgGray';
				this.gray = true;
			}
			if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha !== row.fecha) {
				//this.gray = !this.gray;
				bg = this.gray ? 'bgGray' : '';
			}
			if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha === row.fecha) clase = this.gray ? 'bgGray' : '';
			else if (this.tableData[rowIndex + 1] && this.tableData[rowIndex + 1].fecha === row.fecha) clase = `sacarBorde ${bg}`;
			else clase = `bordeArriba ${bg}`;

			return clase;
		},
		load(row): void {
			row.expandido = true;
			this.codcomexpand = row.codcom2;
			this.codtalexpand = row.codtal2;
			this.numeroexpand = row.numero2;
		},
		getSummaries(param): Object {
			const { columns, data } = param;
			const sums: string[] = [];
			columns.forEach((column, index) => {
				if (index === 4) {
					sums[index] = 'Totales';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) sums[index] = this.totales[column.property];
				else sums[index] = '';
			});

			return sums;
		},
		range(array, min, max): void {
			return array.slice(min, max);
		},
		changeGrano(tab: any): void {
			// this.$router.push(`/1/granos/${this.granos[parseInt(tab.index)].grano}/${this.searchForm.cosechaselect}`);
			// this.granoselected = this.granos[parseInt(tab.index)].grano;
			const i = parseInt(tab.index);
			const gr = this.granos[i] && this.granos[i].grano;
			const hasCosecha = Array.isArray(this.searchForm.cosechaselect) && this.searchForm.cosechaselect.length > 0;
			const cosechaPart = hasCosecha ? `/${this.searchForm.cosechaselect}` : '';
			const target = `/1/granos/${gr}${cosechaPart}`;

			// Guard: si ya estoy en esa ruta, no navego
			if (
				this.$route.path === target ||
				(String(this.$route.params.grano) === String(gr) &&
					(hasCosecha ? String(this.$route.params.cosecha) === String(this.searchForm.cosechaselect) : !this.$route.params.cosecha))
			) {
				this.granoselected = gr;
				return;
			}

			this.$router.push(target).catch(err => {
				if (!err || err.name !== 'NavigationDuplicated') throw err;
			});
			this.granoselected = gr;
		},
		// Muestro el drawer con los detalles del movimiento
		showDetails(record: Comprobante): void {
			this.detailsDrawer = !this.detailsDrawer;
			this.recordSelected = record;
			this.tableGranos = this.recordSelected.renglonesOtros && this.recordSelected.renglonesOtros.length !== 0;
		},
		// Busqueda que se realiza en el drawer
		// doSearch(): void {
		// 	//TODO: refactor
		// 	const me = this;
		// 	const gra = this.granos.filter(function (gr: Grano) {
		// 		return gr.descripcion == me.active_tab;
		// 	});
		// 	if (!this.responsive.isMobile) {
		// 		this.searchForm.fechaDesde = this.searchForm.rangofecha[0] ? this.convertDate(this.searchForm.rangofecha[0]) : ' ';
		// 		this.searchForm.fechaHasta = this.searchForm.rangofecha[1] ? this.convertDate(this.searchForm.rangofecha[1]) : ' ';
		// 	} else {
		// 		this.searchForm.fechaDesdeM = this.searchForm.fechaDesde ? this.convertDate(this.searchForm.fechaDesde) : ' ';
		// 		this.searchForm.fechaHastaM = this.searchForm.fechaHasta ? this.convertDate(this.searchForm.fechaHasta) : ' ';
		// 	}
		// 	this.$router.push(`/1/granos/${gra[0].grano}/${this.searchForm.cosechaselect}`);
		// 	this.searchDrawer = false;
		// 	this.resetData();
		// 	this.callResumen();
		// },
		doSearch(): void {
			// 1) Preparar/validar el grano seleccionado
			let list = Array.isArray(this.granos) ? this.granos : [];
			let gra: any = null;
			for (let i = 0; i < list.length; i++) {
				if (list[i].descripcion === this.active_tab) {
					gra = list[i];
					break;
				}
			}

			// Helper para cerrar el drawer y luego avisar
			let closeThenWarn = (msg: string) => {
				this.searchDrawer = false;
				this.$nextTick(() => {
					if (this.$message && this.$message.warning) this.$message.warning(msg);
				});
			};

			if (!gra) {
				closeThenWarn('Seleccione un grano válido');
				return;
			}

			// 2) Fechas: NO pises los v-model con string en mobile
			if (!this.responsive.isMobile) {
				let rf = this.searchForm && this.searchForm.rangofecha ? this.searchForm.rangofecha : [];
				this.searchForm.fechaDesde = rf.length > 0 ? this.convertDate(rf[0]) : ' ';
				this.searchForm.fechaHasta = rf.length > 1 ? this.convertDate(rf[1]) : ' ';
			} else {
				this.searchForm.fechaDesdeM = this.searchForm.fechaDesde ? this.convertDate(this.searchForm.fechaDesde as any) : ' ';
				this.searchForm.fechaHastaM = this.searchForm.fechaHasta ? this.convertDate(this.searchForm.fechaHasta as any) : ' ';
			}

			// 3) Construir ruta destino SIN barra final si no hay cosecha
			let hasCosecha = Array.isArray(this.searchForm.cosechaselect) && this.searchForm.cosechaselect.length > 0;
			let cosechaPart = hasCosecha ? '/' + this.searchForm.cosechaselect : '';
			let target = '/1/granos/' + gra.grano + cosechaPart;

			// 4) Cerrar el drawer YA, así cualquier mensaje se ve encima
			this.searchDrawer = false;

			// 5) Si ya estamos en esa ruta, no navegamos (evita NavigationDuplicated)
			let sameGrano = this.$route && this.$route.params && String(this.$route.params.grano) === String(gra.grano);
			let sameCosecha = hasCosecha
				? this.$route && this.$route.params && String(this.$route.params.cosecha) === String(this.searchForm.cosechaselect)
				: !(this.$route && this.$route.params && this.$route.params.cosecha);

			if ((this.$route && this.$route.path === target) || (sameGrano && sameCosecha)) {
				// No cambiamos de ruta, solo refrescamos datos
				this.granoselected = gra.grano;
				this.resetData();
				this.callResumen();
				return;
			}

			// 6) Navegar y refrescar datos
			let vm = this;
			this.$router
				.push(target)
				.catch(function (err) {
					if (!err || err.name !== 'NavigationDuplicated') throw err;
				})
				.then(function () {
					vm.granoselected = gra.grano;
					vm.resetData();
					vm.callResumen();
				});
		},
		convertDate(inputFormat: Date): string {
			function pad(s: number) {
				return s < 10 ? '0' + s : s;
			}
			const d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.callResumen();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.callResumen();
		},
		doImprimir(type: string): void {
			let params = {
				url: this.url,
				type: type,
				data: this.loadConfig(),
				cooperativa: this.$store.state.config.cuit,
			};
			window.open(
				`${params.url}?fechaDesde=${params.data.params.fechaDesde}&fechaHasta=${params.data.params.fechaHasta}&codcom=${params.data.params.comprobantes}&codres=${params.data.params.codres}&grano=${params.data.params.grano}&cosecha=${params.data.params.cosecha}&token=${this.$store.state.perfil.remotetoken}&files=true&type=${params.type}&cooperativa=${params.cooperativa}&entity_id=${axios.defaults.headers.common.Entity_ID}`,
				'foo',
				''
			);
		},
		downloadFiles(): void {
			let params = {
				url: this.url,
				data: this.searchForm,
			};
			this.descargando = true;
			this.$store.dispatch('downloadFiles', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar los archivos',
						position: 'top-right',
					});
				}
				this.descargando = false;
			});
		},
		downloadFile(): void {
			let params = {
				recordSelected: this.recordSelected,
			};
			this.imprimiendo = true;
			this.$store.dispatch('downloadFile', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar el archivo',
						position: 'top-right',
					});
				}
				this.imprimiendo = false;
			});
		},
		resetData(): void {
			this.$store.commit('setTableDataGranos', []);
			this.start = 0;
			this.limit = 7;
		},
		//Soluciona el error de filter en granos
		callResumen(): void {
			this.loading = true;
			this.refresh = true;

			const params = { start: this.start, limit: this.limit, data: this.loadConfig() };
			this.$store.dispatch('callResumenGranos', params).then((response: Comprobante[]) => {
				if (response) {
					this.showBtnMore = response.length >= 7;
					this.loading = false;
					this.refresh = false;

					const list = Array.isArray(this.granos) ? this.granos : [];
					const gr =
						this.$route && this.$route.params && this.$route.params.grano
							? this.$route.params.grano
							: list.length > 0
							? list[0].grano
							: null;

					let selected: any = null;
					for (let i = 0; i < list.length; i++) {
						if (String(list[i].grano) === String(gr)) {
							selected = list[i];
							break;
						}
					}
					this.active_tab = selected ? selected.descripcion : '';

					const conta: any = document.querySelector('.el-main');
					if (conta) conta.scrollTop = this.scrollPosition;
				} else {
					this.tableData = [];
					this.loading = false;
				}
			});
		},

		// callResumen(): void {
		// 	this.loading = true;
		// 	this.refresh = true;
		// 	let params = {
		// 		start: this.start,
		// 		limit: this.limit,
		// 		data: this.loadConfig(),
		// 	};
		// 	this.$store.dispatch('callResumenGranos', params).then((response: Comprobante[]) => {
		// 		if (response) {
		// 			response.length < 7 ? (this.showBtnMore = false) : (this.showBtnMore = true);
		// 			this.loading = false;
		// 			this.refresh = false;
		// 			//para seleccionar grano refactor
		// 			const gr = this.$route.params.grano ? this.$route.params.grano : this.granos[0].grano;
		// 			this.active_tab = this.granos.filter((grano: Grano) => {
		// 				return grano.grano == gr;
		// 			})[0].descripcion;
		// 			const conta = document.querySelector('.el-main');
		// 			if (conta) conta.scrollTop = this.scrollPosition;
		// 		} else {
		// 			this.tableData = [];
		// 			this.loading = false;
		// 		}
		// 	});
		// },
		loadConfig(): object {
			let config: object = {
				params: {
					fechadesde: this.responsive.isMobile ? this.searchForm.fechaDesdeM : this.searchForm.fechaDesde,
					fechahasta: this.responsive.isMobile ? this.searchForm.fechaHastaM : this.searchForm.fechaHasta,
					descom: '[' + this.searchForm.comprobantes + ']',
					codres: this.resumen,
					grano: this.granoselected,
					cosecha: '[' + this.searchForm.cosechaselect + ']',
				},
			};
			this.config = config;
			return config;
		},
		numberFormatter(row): string {
			return `${row.codcom2}  ${row.codtal2}  ${row.numero2}`;
		},
		changeResumen(resumen: Resumen): void {
			this.$nextTick(() => {
				const el = document.activeElement as HTMLElement | null;
				if (el && el.classList.contains('el-radio__original')) el.blur();
			});
			this.resumen = resumen;
			this.loading = true;
			this.resetData();
			this.callResumen();
		},
	},
	mounted() {
		const encontrado = this.cosechas.find(element => element.cosecha === parseInt(this.$route.params.cosecha));
		this.granoselected = this.$route.params.grano ? this.$route.params.grano : this.primergrano;
		if (encontrado) this.searchForm.cosechaselect.push(encontrado.cosecha);
		else if (this.granoselected) this.$router.push(`/1/granos/${this.granoselected}`);

		if (!this.responsive.mobile) window.addEventListener('scroll', this.updateScroll);
	},
	destroyed() {
		if (!this.responsive.mobile) window.removeEventListener('scroll', this.updateScroll);
	},
};
